/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 9999eb1d882990f19e352fba26b6c3f62977c8a7
 */

export type EntitlementStatus = typeof EntitlementStatus[keyof typeof EntitlementStatus];


export const EntitlementStatus = {
  active: 'active',
  inactive: 'inactive',
} as const;
